import { GetData, GetDataV2 } from "./Functions/SettingData";

export const getVehicleInfo = async (batteryId) => {
  var config = {
    method: "get",
    url: `/api/vehicle/${batteryId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
};

export const updateVehicleChassisNumber = async (batteryId, data) => {
  var config = {
    method: "post",
    url: `/api/vehicle/${batteryId}/update_vin`,
    data,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let response = await GetDataV2(config);
  return response;
};
